import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import rcmlogo from "../../assets/images/rcmlogo.png";
import { useLocation, useNavigate } from "react-router-dom";
import "./Navigationbar.css";
import { useAppDispatch } from "../../core/redux/hooks";
import { clearAuthSlice } from "../../core/redux/authSlice";
import { useAppSelector } from "../../core/redux/hooks";
import Badge from "react-bootstrap/Badge";
import Container from 'react-bootstrap/Container';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Button from "react-bootstrap/esm/Button";
import { GetApiMethod } from "../../core/services/apiService";

const Navigationbar = (props: any) => {
    const location = useLocation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    let LoginUserDetails = useAppSelector((state) => state.auth.users);
    const [userDetails, setUserDetails] = React.useState<any>();
    const [toggleNavbar, setToggleNavbar] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (LoginUserDetails) {
            setUserDetails(LoginUserDetails);
        }
    }, [LoginUserDetails]);

    const logout = () => {
        localStorage.clear();
        dispatch(clearAuthSlice());
    };
    const DownloadKiosk = (e: any) => {
        e.preventDefault();
        GetApiMethod("package/deb")
            .then((res: any) => {
                console.log(res);
                const url: string = res.data.data;
                let link: any = document.createElement('a');
                link.href = url;
                link.click();
            })
            .catch((err) => {
                console.log(err);
            })
    }
    return (
        <div className="shadow">
            <Navbar bg="light" expand={'lg'} className="mb-3 " fixed="top" collapseOnSelect >
                <Container fluid>
                    <Navbar.Brand
                        onClick={() => navigate("/customer")}
                        className="cursor-pointer"
                    >
                        <img
                            alt=""
                            src={rcmlogo}
                            width="150"
                            height="40"
                            className="d-inline-block align-top"
                        />{" "}
                    </Navbar.Brand>
                    <Badge pill bg="" style={{ fontSize: 16 }} className="ml-3 mr-4 app-button-color">
                        {
                            userDetails && (userDetails.hasOwnProperty('role') ? (userDetails.role === "super_admin" ? "Super Admin" : "") : "")
                        }
                    </Badge>

                    <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-lg`} onClick={() => { setToggleNavbar(!toggleNavbar) }} />
                    <Navbar.Offcanvas
                        id={`offcanvasNavbar-expand-lg`}
                        aria-labelledby={`offcanvasNavbarLabel-expand-lg`}
                        placement="top"
                        enforceFocus={true}
                        scroll={false}
                    >
                        <Offcanvas.Header closeButton >
                            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-lg`}>
                                <img alt="RCM" src={rcmlogo} width="150" height="40" className="d-inline-block align-top" />
                            </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <Nav className="justify-content-start navigation-bar-nav flex-grow-1">
                                <Nav.Link
                                    eventKey={
                                        location.pathname === "/super-admin/edit" ? "/super-admin/edit" :
                                            location.pathname === "/super-admin/create" ? "/super-admin/create" :
                                                location.pathname === "/super-admin" ? "/super-admin" : "/super-admin"
                                    }
                                    onClick={() =>
                                        navigate("/super-admin")
                                    }
                                    className={
                                        location.pathname === "/super-admin" ||
                                            location.pathname === "/super-admin/create" ||
                                            location.pathname === "/super-admin/edit"
                                            ? "super-admin active"
                                            : "super-admin"
                                    }
                                >
                                    Super Admin
                                </Nav.Link>
                                <Nav.Link
                                    eventKey={
                                        location.pathname === "/customer-admin/edit" ? "/customer-admin/edit" :
                                            location.pathname === "/customer-admin/create" ? "/customer-admin/create" :
                                                location.pathname === "/customer-admin" ? "/customer-admin" : "/customer-admin"
                                    }
                                    onClick={() =>
                                        navigate("/customer-admin")
                                    }
                                    className={
                                        location.pathname === "/customer-admin" ||
                                            location.pathname === "/customer-admin/create" ||
                                            location.pathname === "/customer-admin/edit"
                                            ? "customer-admin active"
                                            : "customer-admin"
                                    }
                                >
                                    Customer Admin
                                </Nav.Link>
                                <Nav.Link
                                    eventKey={
                                        location.pathname === "/customer/edit" ? "/customer/edit" :
                                            location.pathname === "/customer/create" ? "/customer/create" :
                                                location.pathname === "/customer" ? "/customer" : "/customer"
                                    }
                                    onClick={() =>
                                        navigate("/customer")
                                    }
                                    className={
                                        location.pathname === "/customer" ||
                                            location.pathname === "/customer/create" ||
                                            location.pathname === "/customer/edit"
                                            ? "customer active"
                                            : "customer"
                                    }
                                >
                                    Customer
                                </Nav.Link>
                                <Nav.Link
                                    onClick={() =>
                                        navigate("/settings")
                                    }
                                    eventKey="/settings"
                                    className={
                                        location.pathname === "/settings"
                                            ? "settings active"
                                            : "settings"
                                    }
                                >
                                    Settings
                                </Nav.Link>
                                <Nav.Link eventKey="" onClick={DownloadKiosk}>
                                    <Button variant="danger" size="sm" style={{ height: 'auto', maxWidth: 150 }} ><i className="fa fa-download mr-1"></i><b> Download Kiosk </b></Button>
                                </Nav.Link>
                            </Nav>

                            <Nav className="justify-content-end navigation-bar-nav flex-grow-1">
                                <NavDropdown align="end" className="" title={<i className="fa fa-user-circle p-1" style={{ fontSize: 35, color: "#0187c4" }}></i>}>
                                    <NavDropdown.Item>
                                        <h5>{userDetails?.name}</h5>
                                        <label className="text-small" >{userDetails?.email}</label>
                                    </NavDropdown.Item>
                                    <NavDropdown.Item
                                        className="text-primary"
                                        onClick={() => logout()}
                                    >
                                        <Button className="btn btn-sm" ><i className="fa fa-sign-out" aria-hidden="true"></i>{" "}Logout</Button>
                                    </NavDropdown.Item>
                                </NavDropdown>
                            </Nav>
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>
                </Container>
            </Navbar>
            {/* </nav> */}
        </div>
    );
};

export default Navigationbar;
